import requestv2 from "~/utils/http-v2";

const probationHistoryApi = {
	gets: async (userId) => {
		const url = 'v2/probation-history';
		return await requestv2.get(url, {params: {userId}});
	},
	add: async (params) => {
		const url = 'v2/probation-history';
		return await requestv2.post(url, params);
	},
	update: async (params) => {
		const url = `v2/probation-history/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete: async (id) => {
		const url = `v2/probation-history/${id}`;
		return await requestv2.delete(url);
	},
};

export default probationHistoryApi;
